import React from 'react';
import LoadingBackdrop from '../Common/LoadingBackdrop';

export default function Suspense(props: { children: React.ReactNode }) {
  const { children } = props;
  return (
    <React.Suspense fallback={<LoadingBackdrop />}>
      {children}
    </React.Suspense>
  );
}
